import setDocumentTitle from 'I18n/utils/setDocumentTitle';
export const setFavicon = faviconUrl => {
  if (!faviconUrl) {
    return;
  }
  const currentFavicons = document.querySelectorAll("link[rel*='icon']");
  if (currentFavicons.length) {
    currentFavicons.forEach(favicon => {
      var _document$querySelect;
      favicon.href = faviconUrl;
      (_document$querySelect = document.querySelector('head')) === null || _document$querySelect === void 0 || _document$querySelect.appendChild(favicon);
    });
  }
};
export const setTabTitle = companyName => {
  if (!companyName) {
    return;
  }
  setDocumentTitle('app.htmlTitleCompanyName', {
    companyName
  });
};